import { defineMessages } from 'react-intl';

export default defineMessages({
    noInfo: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorHomeInspection.noInfo',
        defaultMessage: 'No information is available to display'
    },
    changeInspectionInfo: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorHomeInspection.changeInspectionInfo',
        defaultMessage: 'To change the inspection from on-site or self-survey, contact Underwriting before the policy effective date'
    },
    homeInspection: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorHomeInspection.Home Inspection',
        defaultMessage: 'Home Inspection'
    },
    inspectionStatus: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorHomeInspection.Inspection Status',
        defaultMessage: 'Inspection Status'
    },
    inspectionOrdered: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorHomeInspection.Inspection Ordered',
        defaultMessage: 'Inspection Ordered'
    },
    inspectionReturned: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorHomeInspection.Inspection Returned',
        defaultMessage: 'Inspection Returned'
    },
    inspectionType: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorHomeInspection.Inspection Type',
        defaultMessage: 'Inspection Type'
    },
    inspectionCompany: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorHomeInspection.Inspection Company',
        defaultMessage: 'Inspection Company'
    },
    viewHomeInspection: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorHomeInspection.View Home Inspection',
        defaultMessage: 'View Home Inspection'
    }
});